"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Resize = _interopRequireDefault(require("@rsuite/icon-font/lib/layout/Resize"));

// Generated by script, don't edit it please.
var Resize = (0, _createSvgIcon["default"])({
  as: _Resize["default"],
  ariaLabel: 'resize',
  category: 'layout',
  displayName: 'Resize'
});
var _default = Resize;
exports["default"] = _default;
module.exports = exports.default;